<script setup>
import {computed} from "vue";
const colorMap = {
  default: "#6B6B6B",
  black: "#191919",
  alert: "#df4c4c",
  primary: "#0b5eac",
  white: "#fff"
}

const props = defineProps({
  name: {
    type: String,
    required: true
  },
})
const symbolId = computed(() => `#icon-${props.name}`)
</script>

<template lang="pug">
  svg(aria-hidden="true")
      use(:href="symbolId")
</template>
